import Typography from "@mui/material/Typography";
import { invalidateArticleListQuery } from "entities/manageArticles/queries/useArticleListQuery";
import { ArticleBrandId, ArticleCategory } from "entities/manageArticles/types";
import { FC } from "react";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import PrimaryButton from "shared/components/PrimaryButton";
import { useModalState } from "shared/hooks/useModalState";
import { MANAGE_ARTICLES_PATH } from "shared/routes/paths";
import { ArrowBackIcon } from "shared/theme/icons/ArrowBack";
import CreatingArticleModal from "../CreatingArticleModal";

type ArticleGroupHeaderProps = {
  title: string;
};

const ArticleGroupHeader: FC<ArticleGroupHeaderProps> = ({ title }) => {
  const { isOpen, openModal, closeModal } = useModalState();
  const { brandId, categoryId } = useParams();
  const navigate = useNavigate();

  const navigateToPreviousPage = () => {
    const path = generatePath(MANAGE_ARTICLES_PATH, {
      brandId: brandId as string,
      categoryId: categoryId as string,
    });

    navigate(path);


    invalidateArticleListQuery({
      brandId: brandId as ArticleBrandId,
      categoryId: categoryId as ArticleCategory,
    });
  };

  return (
    <>
      <FlexCenter justifyContent="space-between" width="100%">
        <FlexCenter gap={"1rem"}>
          <FlexCenter onClick={navigateToPreviousPage}>
            <ArrowBackIcon />
          </FlexCenter>
          <Typography variant="heading4">{title}</Typography>
        </FlexCenter>
        <PrimaryButton title={"New"} size="small" onClick={openModal} />
      </FlexCenter>
      <CreatingArticleModal open={isOpen} onClose={closeModal} />
    </>
  );
};

export default ArticleGroupHeader;
